const DELIMITER = ' | ';
const MARKER_REGEX = /\n\n📎 \[(.+)\]$/;

/** Sanitize a filename by stripping control characters and newlines. */
function sanitizeFilename(name: string): string {
  // eslint-disable-next-line no-control-regex
  return name.replace(/[\x00-\x1f\x7f]/g, '').trim();
}

export function buildAttachmentMarker(filenames: string[]): string {
  if (filenames.length === 0) return '';
  return `\n\n📎 [${filenames.map(sanitizeFilename).join(DELIMITER)}]`;
}

export function parseAttachmentMarker(content: string): { text: string; filenames: string[] | null } {
  const match = content.match(MARKER_REGEX);
  if (!match) {
    return { text: content, filenames: null };
  }
  return {
    text: content.slice(0, match.index!),
    filenames: match[1]!.split(DELIMITER),
  };
}
